<div class="table-container">
    <div class="table-header">
        <h2>Mitarbeiterliste</h2>
        <div class="employee-sync-status">
            <span class="employee-sync-status-text" [class.employee-sync-status-failed]="employeeSyncStatus().state === 'FAILED'">
                <svg *ngIf="isSyncingEmployees()" class="spinner-icon-small" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
                </svg>
                {{ employeeSyncStatusText() }}
            </span>
            <button
                type="button"
                class="retry-sync-button employee-sync-button"
                title="Vollen Mitarbeiter-Abgleich mit DATEV anstoßen"
                [disabled]="isSyncingEmployees()"
                (click)="syncEmployees()">
                Mitarbeiter synchronisieren
            </button>
        </div>
    </div>

    <div class="search-section">
        <div class="search-field">
            <label for="searchInput">Mitarbeiter suchen:</label>
            <input
                id="searchInput"
                type="text"
                placeholder="Suche nach Mitarbeiternummer, Name oder E-Mail..."
                [ngModel]="searchTerm()"
                (ngModelChange)="searchTerm.set($event); filterEmployees()"
                class="search-input"
            >
            <button
                *ngIf="searchTerm()"
                class="clear-search-button"
                (click)="clearSearch()"
                title="Suche löschen">
                ×
            </button>
        </div>
        <div class="search-results" *ngIf="searchTerm()">
            {{ filteredEmployees().length }} von {{ employees().length }} auf dieser Seite gefunden
        </div>
    </div>

    <div class="loading-spinner" *ngIf="loading()">
        Lade Daten...
    </div>

    <table *ngIf="!loading()">
        <thead>
        <tr>
            <th>Mitarbeiternummer</th>
            <th>Name</th>
            <th>E-Mail</th>
            <th>Aktionen</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let employee of filteredEmployees()"
            class="clickable-row"
            [class.test-employee]="employee.is_test_employee">
            <td (click)="showEmployeeSickLeaves(employee)">{{employee.datevEmployeeNumber}}</td>
            <td (click)="showEmployeeSickLeaves(employee)">{{employee.name}}</td>
            <td (click)="showEmployeeSickLeaves(employee)" class="email-cell">
                <div class="email-value">
                    <span>{{employee.email}}</span>
                    <span class="status-badge status-pending email-sync-badge" *ngIf="employee.email_sync_status === 'PENDING'">
                        <svg class="spinner-icon-small" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
                        </svg>
                        wird synchronisiert...
                    </span>
                </div>
                <div class="email-sync-failed" *ngIf="employee.email_sync_status === 'FAILED'">
                    <span class="status-badge status-error email-sync-badge">Synchronisierung fehlgeschlagen</span>
                    <div class="email-sync-error" *ngIf="employee.email_sync_error">{{employee.email_sync_error}}</div>
                    <button
                        type="button"
                        class="retry-sync-button"
                        title="Email-Synchronisierung erneut versuchen"
                        [disabled]="isRetryingEmailSync(employee)"
                        (click)="$event.stopPropagation(); retryEmailSync(employee)">
                        {{ isRetryingEmailSync(employee) ? 'Wird erneut versucht...' : 'Erneut versuchen' }}
                    </button>
                </div>
            </td>
            <td class="action-cell">
                <div *ngIf="employee.isSick !== 1" class="no-sick-leaves-icon" title="Keine aktive Krankmeldung">
                    <fa-icon [icon]="healthyIcon"></fa-icon>
                </div>
                <button
                    *ngIf="employee.isSick === 1"
                    class="action-button icon-button medical-button"
                    (click)="showEmployeeSickLeaves(employee)"
                    title="Krankmeldungen anzeigen">
                    <fa-icon [icon]="medicalIcon"></fa-icon>
                </button>
                <button
                    class="action-button icon-button sick-leave-button"
                    [disabled]="!datevAuthService.getAuthStatus()()"
                    (click)="showSickLeaveForm(employee)"
                    [title]="datevAuthService.getAuthStatus()() ? 'Krankmeldung erstellen' : 'DATEV Authentifizierung erforderlich'">
                    <fa-icon [icon]="sickLeaveIcon"></fa-icon>
                </button>
                <button
                    class="action-button icon-button edit"
                    (click)="startEdit(employee)"
                    title="Mitarbeiter bearbeiten">
                    <fa-icon [icon]="editIcon"></fa-icon>
                </button>
            </td>
        </tr>
        <tr *ngIf="filteredEmployees().length === 0 && employees().length > 0">
            <td colspan="4" class="no-data">Keine Mitarbeiter gefunden, die den Suchkriterien entsprechen</td>
        </tr>
        <tr *ngIf="employees().length === 0 && !loading()">
            <td colspan="4" class="no-data">Keine Mitarbeiter vorhanden</td>
        </tr>
        </tbody>
    </table>

    <div class="pagination" *ngIf="!loading() && totalEmployees() > 0">
        <div class="pagination-info">
            {{ totalEmployees() }} Mitarbeiter gesamt
        </div>
        <div class="pagination-controls">
            <button
                class="pagination-button"
                [disabled]="currentPage() <= 0"
                (click)="prevPage()"
                title="Vorherige Seite">
                <fa-icon [icon]="prevIcon"></fa-icon>
            </button>
            <span class="pagination-pages">
                Seite {{ currentPage() + 1 }} von {{ totalPages() }}
            </span>
            <button
                class="pagination-button"
                [disabled]="currentPage() >= totalPages() - 1"
                (click)="nextPage()"
                title="Nächste Seite">
                <fa-icon [icon]="nextIcon"></fa-icon>
            </button>
        </div>
        <div class="pagination-size">
            <label for="pageSize">Pro Seite:</label>
            <select
                id="pageSize"
                [ngModel]="pageSize()"
                (ngModelChange)="onPageSizeChange($event)">
                <option [ngValue]="10">10</option>
                <option [ngValue]="25">25</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>
            </select>
        </div>
    </div>

    <app-employee-sick-leave-modal
        [employee]="selectedEmployee()"
        (close)="closeEmployeeSickLeaves()">
    </app-employee-sick-leave-modal>

    <app-employee-sick-leave-form-modal
        [employee]="selectedEmployeeForSickLeave()"
        (close)="closeSickLeaveForm()">
    </app-employee-sick-leave-form-modal>

    <div class="edit-overlay" *ngIf="editingEmployee()" (click)="cancelEdit()">
        <div class="edit-modal" (click)="$event.stopPropagation()">
            <div class="edit-header">
                <h3>{{ datevAuthService.getAuthStatus()() ? 'Mitarbeiter bearbeiten' : 'Mitarbeiter Details' }} — {{ editingEmployee()!.name }}</h3>
                <button class="edit-close" (click)="cancelEdit()">×</button>
            </div>
            <div class="edit-body">
                <div class="edit-section">
                    <label>Arbeitstage und Arbeitszeit:</label>
                    <div class="working-days">
                        <ng-container *ngFor="let day of allDays">
                            <div *ngIf="getHoursForDay(editingEmployee()!, day) > 0"
                                 class="working-day-item active">
                                <span class="working-day-label">{{ workingDayLabels[day] }}</span>
                                <span class="working-day-hours">{{ getHoursForDay(editingEmployee()!, day) }}h</span>
                            </div>
                        </ng-container>
                    </div>
                    <div class="weekly-hours-total">
                        Wochenstunden gesamt: <strong>{{ editingEmployee()!.weekly_working_hours ?? 0 }}h</strong>
                    </div>
                </div>

                <div class="edit-section">
                    <label for="editEmailInput">E-Mail-Adresse:</label>
                    <input
                        id="editEmailInput"
                        type="email"
                        class="edit-input"
                        [ngModel]="editEmail()"
                        (ngModelChange)="editEmail.set($event)"
                        placeholder="email@beispiel.de"
                        [readonly]="!datevAuthService.getAuthStatus()()"
                    >
                </div>

                <div class="edit-section">
                    <label for="editReasonForAbsence">Abwesenheitsschlüssel:</label>
                    <select
                        id="editReasonForAbsence"
                        class="edit-select"
                        [ngModel]="editReasonForAbsence()"
                        (ngModelChange)="editReasonForAbsence.set($event)"
                        [disabled]="!datevAuthService.getAuthStatus()()">
                        <option *ngFor="let code of reasonCodes()" [value]="code.code">
                            {{ code.code }} — {{ code.label }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="edit-actions">
                <button
                    *ngIf="datevAuthService.getAuthStatus()()"
                    class="edit-save"
                    [disabled]="!editEmail().trim() || editLoading()"
                    (click)="saveEdit()">
                    {{ editLoading() ? 'Speichern...' : 'Speichern' }}
                </button>
                <button class="edit-cancel" (click)="cancelEdit()">
                    {{ datevAuthService.getAuthStatus()() ? 'Abbrechen' : 'Schließen' }}
                </button>
            </div>
        </div>
    </div>
</div>
